import { render, staticRenderFns } from "./Matters.vue?vue&type=template&id=d5d08b44"
import script from "./Matters.vue?vue&type=script&lang=js"
export * from "./Matters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports